import React, { Component } from 'react'
import * as _ from 'lodash'
import './style.css'

import State from '../State'
import Logic from '../Logic'

import ExclamationSymbol from '../ExclamationSymbol'
import CloseButtonIcon from '../CloseButtonIcon'


class ResultPopup extends Component {

  // Show different text depending on OOB, POOB or OK
  // If explore more, add 'now' to 'Your result is...'
  // If balance changes from OOB to POOB, or from POOB to OK, show this popup

  handleCloseClick = function() {
    State.action('closeResultPopup')
  }

  render() {

    var classes = 'result-popup'
    if(State.ui.showResultPopup && !State.ui.showAboutPopup)
      classes += ' active'

    let result = Logic.getBalance(State.survey, 'chosenAnswer')

    let flaggedQuestions = _.map(State.derived.flaggedQuestions, fq => {
      let q = State.survey[fq.sectionId].questions[fq.questionId]
      // console.log(q, )
      return <tr className="flagged-question" key={q.id}>
        <td className="question-text">{q.text}</td>
        <td className="answer">{q.answers[q.chosenAnswer].text}</td>
      </tr>
    })
    let flaggedQuestionsTable = <table><tbody>{flaggedQuestions}</tbody></table>

    let changedAnswers = []
    if(State.ui.explore) {
      changedAnswers = Logic.getChangedAnswers(State.survey)
    }
    changedAnswers = _.map(changedAnswers, q => <tr className="changed-answer" key={q.id}>
      <td className="question-text">{q.text}</td>
      <td className="changed-answer-detail"><span className="new-answer">{q.answers[q.chosenAnswer].text}</span> <span className="previous-answer">(was {q.answers[q.originalChosenAnswer].text})</span></td>
    </tr>)
    let changedAnswersTable = <table><tbody>{changedAnswers}</tbody></table>

    let nowText = changedAnswers.length > 0 ? 'now' : ''

    let balanceImage = `./img/results/${result}.png`
    let imageRotate = Logic.getImageRotation(State.survey, 'chosenAnswer')

    let bodyText = {
      'ok': <div className="body"><p>Well done! Based on your answers your home is {nowText} in balance with respect to moisture.</p>{flaggedQuestions.length > 0 ? <div><h3>Areas to watch out for</h3><p>Some of your answers help keep your home within balance, however there could be some areas to watch out for:</p>{flaggedQuestionsTable}<p>The most significant areas of these are marked with a <ExclamationSymbol r="10" /> symbol.</p></div> : null}<p>Feel free to explore the effect of changing your answers:</p></div>,
      'poob': <div className="body"><p>Your home is {nowText} possibly out of balance with respect to moisture.</p><p>Don’t panic. Address what you can of the areas below but don’t worry if changes in these areas are beyond what you can do. Keep a watchful eye towards moisture issues such as damp or mould within the home.</p><h3>Areas of attention</h3><p>Based on your answers, there are areas where changes could help bring your home into balance.</p><p>The most significant areas are:</p>{flaggedQuestionsTable}<p>These are marked by a <ExclamationSymbol r="10" /> symbol in the survey. Try changing your answers to see what actions could help bring your home back into balance:</p></div>,
      'oob': <div className="body"><p>Your home is out of balance with respect to moisture.</p><p>You need to address as many of the areas below as you can to try and get the house back into balance. Changes in some areas may be beyond what you can do. Aim to reduce moisture generation, keep up maintenance, keep the house warm and ventilate well.</p><h3>Areas of attention</h3><p>Based on your answers, there are areas where changes could help bring your home into balance.</p><p>The most significant areas are:</p>{flaggedQuestionsTable}<p>These are marked by a <ExclamationSymbol r="10" /> symbol in the survey. Try changing your answers to see what actions could help bring your home back into balance:</p></div>,
    }

    return (
      <div className={classes}>
        <div className="close-button"><CloseButtonIcon clickHandler={this.handleCloseClick} /></div>

        <div className="headline">
          {changedAnswers.length > 0 ? '' : <div className="thank-you">Thank you for completing the questionnaire!</div>}
          {/*}<div>Your result is {nowText}:</div>*/}
        </div>
        <div className="result"><img src={balanceImage} alt="Sketch of house" style={{transform: `rotate(${imageRotate}deg)`}} /><span>{Logic.getBalanceString(result)}</span></div>
        <div className="body-wrapper">{bodyText[result]}</div>
        <div className="button-wrapper"><div onClick={this.handleCloseClick} className="button">Review your answers</div></div>
        {changedAnswers.length > 0 ? <h3>Your changed answers</h3> : ''}
        <div className="changed-answers">{changedAnswersTable}</div>
        <div className="what-next">
          <h3>What next?</h3>
          <div>For more information of moisture in buildings and how to keep moisture at a healthy level see <a href="http://www.ukcmb.org">www.ukcmb.org</a>.</div>
          <div>Watch the UKCMB video for homeowners <a href="http://www.ukcmb.org/resources/Outputs">here</a> which gives a simple explanation of moisture in buildings and some key practical advice.</div>
          <div>To consult an expert on moisture within homes get in touch with the UKCMB: <a href="mailto:ukcmb@ucl.ac.uk">ukcmb@ucl.ac.uk</a>.</div>
        </div>
        <div className="reset-answers"><a href={window.location.href.split('#')[0]}>Reset your answers</a></div>
        <div className="button-wrapper"><div onClick={this.handleCloseClick} className="button">Close</div></div>
      </div>
    );
  }
}

        // <div>To see the effect of changing your answers click Explore:</div>
//        <div className="button-wrapper"><div onClick={this.handleCloseClick} className="button">{changedAnswers.length > 0 ? 'Continue' : 'Start'} exploring</div></div>
// {changedAnswers.length > 0 ? <div>Your changes are:</div> : <div>If you like you can now explore the survey and modify your answers to see what effect any changes you make will have.</div>}
// <div>Continue to explore the survey and modify your answers to see if you can bring your home into balance.</div>
// <div>Now explore the survey and modify your answers to see if you can bring your home into balance.</div>
export default ResultPopup;



// WEBPACK FOOTER //
// ./src/ResultPopup/index.js